import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from "react";
import { CircleSlider } from "./CircleSlider/CircleSlider";
import EventsSlider from "./EventSlider/EventsSlider";
import { timelineData } from "../../data/data";
import "../../styles/Timeline/Timeline.scss";
const Timeline = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const slidesData = useMemo(() => timelineData.periods.map((period) => ({
        id: period.id,
        startYear: period.yearsOne,
        endYear: period.yearsTwo,
        title: period.title,
    })), [timelineData]);
    const eventsData = useMemo(() => timelineData.periods.map((period) => period.events.map((event) => ({
        year: event.year,
        text: event.description,
    }))), [timelineData]);
    return (_jsx("div", { className: "container", children: _jsxs("div", { className: "timeline", children: [_jsxs("div", { className: "cross-lines", children: [_jsx("div", { className: "cross-line horizontal" }), _jsx("div", { className: "cross-line vertical" })] }), _jsx("div", { className: "timeline-title", children: _jsxs("h1", { className: "timeline-title_h1", children: ["\u0418\u0441\u0442\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0435 ", _jsx("span", { children: "\u0434\u0430\u0442\u044B" })] }) }), _jsxs("div", { className: "timeline-content", children: [_jsx(CircleSlider, { slides: slidesData, activeSlide: activeSlide, onSlideChange: setActiveSlide }), _jsx(EventsSlider, { events: eventsData[activeSlide] || [] })] })] }) }));
};
export default Timeline;
